/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: c3d9d0a0 (Wed Sep 23 18:58:40 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  AgreementRecord,
  AgreementRecordFromJSON,
  BulkReassignTeamMemberRequestBody,
  BulkReassignTeamMemberRequestBodyToJSON,
  ExpireTeamMemberRequestParams,
  ExpireTeamMemberRequestParamsToJSON,
  InviteTeamMemberOptions,
  InviteTeamMemberOptionsFromJSON,
  InviteTeamMemberRequestBody,
  InviteTeamMemberRequestBodyToJSON,
  ResendInvitationTeamMemberRequestBody,
  ResendInvitationTeamMemberRequestBodyToJSON,
  ResendInviteEmail,
  ResendInviteEmailFromJSON,
  UserTeamAgreementsResponse,
  UserTeamAgreementsResponseFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface BulkReassignTeamMembersRequest
  extends runtime.BaseRequestParameters {
  body: BulkReassignTeamMemberRequestBody
}

export interface ExpireTeamMemberRequest extends runtime.BaseRequestParameters {
  body: ExpireTeamMemberRequestParams
}

export interface FetchInviteTeamMemberOptionsRequest
  extends runtime.BaseRequestParameters {}

export interface FetchTeamAgreementsForUserRequest
  extends runtime.BaseRequestParameters {
  userId: string
  page?: number
  pageSize?: number
  orderBy?: Array<string>
  actorKey?: number
  invitationStatus?: string
  search?: string
  downlineOnly?: boolean
}

export interface InviteTeamMemberRequest extends runtime.BaseRequestParameters {
  body: InviteTeamMemberRequestBody
}

export interface ResendTeamMemberRequest extends runtime.BaseRequestParameters {
  body: ResendInvitationTeamMemberRequestBody
}

/**
 * TeamsApi - interface
 *
 * @export
 * @interface TeamsApiInterface
 */
export interface TeamsApiInterface {
  /**
   *  Reassigns multiple team members from one supervisor to another in a single operation. This updates the `reportsToActorKey` for each specified actor, effectively moving them under a new supervisor.  ## Permissions: - **User/bulkReassignRoles[their team\'s]** grant allows the calling actor to reassign actors within their downline to report to a new supervisor also within the calling actor\'s downline. The new supervisor must be currently active. - **User/bulkReassignRoles[any]** grant allows the calling actor to reassign any actors to any supervisor. The new supervisor must be currently active.  Note: Users on the front end may select a ton of actors to reassign, and they may not realize they\'ve selected actors that are currently inactive. Instead of returning an error indicating that there are inactive actors in their request, we silently ignore them and reassign the currently active ones.
   * @param {BulkReassignTeamMemberRequestBody} bulkReassignTeamMemberRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TeamsApiInterface
   */
  bulkReassignTeamMembersRaw(
    requestParameters: BulkReassignTeamMembersRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   *  Reassigns multiple team members from one supervisor to another in a single operation. This updates the `reportsToActorKey` for each specified actor, effectively moving them under a new supervisor.  ## Permissions: - **User/bulkReassignRoles[their team\'s]** grant allows the calling actor to reassign actors within their downline to report to a new supervisor also within the calling actor\'s downline. The new supervisor must be currently active. - **User/bulkReassignRoles[any]** grant allows the calling actor to reassign any actors to any supervisor. The new supervisor must be currently active.  Note: Users on the front end may select a ton of actors to reassign, and they may not realize they\'ve selected actors that are currently inactive. Instead of returning an error indicating that there are inactive actors in their request, we silently ignore them and reassign the currently active ones.
   */
  bulkReassignTeamMembers(
    requestParameters: BulkReassignTeamMembersRequest
  ): Promise<void>

  /**
   * Expire a team member on the current user\'s team. This translates to setting the validTo date to the current date for that actor. Also, if available, sets the agreementRecord related to the actor to cancelled and sets the cancelled date.
   * @param {ExpireTeamMemberRequestParams} expireTeamMemberRequestParams
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TeamsApiInterface
   */
  expireTeamMemberRaw(
    requestParameters: ExpireTeamMemberRequest
  ): Promise<runtime.ApiResponse<void>>

  /**
   * Expire a team member on the current user\'s team. This translates to setting the validTo date to the current date for that actor. Also, if available, sets the agreementRecord related to the actor to cancelled and sets the cancelled date.
   */
  expireTeamMember(requestParameters: ExpireTeamMemberRequest): Promise<void>

  /**
   *
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TeamsApiInterface
   */
  fetchInviteTeamMemberOptionsRaw(
    requestParameters: FetchInviteTeamMemberOptionsRequest
  ): Promise<runtime.ApiResponse<InviteTeamMemberOptions>>

  /**
   */
  fetchInviteTeamMemberOptions(): Promise<InviteTeamMemberOptions>

  /**
   * It will fetch the users agreements record that was sent out to for the previous and current academic Year for    the logged in user if userId = me in case the end point send query string with the actorKey it will also fetch the actor   downline team agreements for the provided actorKey. It will return the user agreements  sent out for the current    and previous academic year, it will return the Name, Email, Role Date Sent, Type of Invite, and the Status of the invitation.\",
   * @summary Fetch user\'s agreements that was sent out for the previous and current academic year for the logged in user    if the end point send query string with the actorKey it will also fetch the actor downline team agreements for the provided actorKey.
   * @param {string} userId If &#x60;me&#x60;, then the current &#x60;userId&#x60; from the session will be used.
   * @param {number} [page] The current page of data to be returned. Must be at least 1.
   * @param {number} [pageSize] The length of data to be returned on the requested page. Must be at least 1
   * @param {Array<string>} [orderBy] The order by properties and direction for the data in the endpoint. See endpoint description for what is applicable. Must be in a format like: \&#39;property ASC\&#39;
   * @param {number} [actorKey] The unique identifier for the actor record that we should pull the teams Agreements for.
   * @param {string} [invitationStatus] The agreement record status by which to filter.
   * @param {string} [search] Search for users by signerEmail, roleName, and signerName. Must be at least 3 characters in length.
   * @param {boolean} [downlineOnly] If supplied and true, only users and actors that are in the requester\&#39;s downline team are returned.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TeamsApiInterface
   */
  fetchTeamAgreementsForUserRaw(
    requestParameters: FetchTeamAgreementsForUserRequest
  ): Promise<runtime.ApiResponse<UserTeamAgreementsResponse>>

  /**
   * It will fetch the users agreements record that was sent out to for the previous and current academic Year for    the logged in user if userId = me in case the end point send query string with the actorKey it will also fetch the actor   downline team agreements for the provided actorKey. It will return the user agreements  sent out for the current    and previous academic year, it will return the Name, Email, Role Date Sent, Type of Invite, and the Status of the invitation.\",
   * Fetch user\'s agreements that was sent out for the previous and current academic year for the logged in user    if the end point send query string with the actorKey it will also fetch the actor downline team agreements for the provided actorKey.
   */
  fetchTeamAgreementsForUser(
    requestParameters: FetchTeamAgreementsForUserRequest
  ): Promise<UserTeamAgreementsResponse>

  /**
   *
   * @summary Send out an email invitation and agreement to a prospective team member.
   * @param {InviteTeamMemberRequestBody} inviteTeamMemberRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TeamsApiInterface
   */
  inviteTeamMemberRaw(
    requestParameters: InviteTeamMemberRequest
  ): Promise<runtime.ApiResponse<AgreementRecord>>

  /**
   * Send out an email invitation and agreement to a prospective team member.
   */
  inviteTeamMember(
    requestParameters: InviteTeamMemberRequest
  ): Promise<AgreementRecord>

  /**
   * This endpoint resend an invite email for a prospective team member that previously signed the contract
   * @summary Resend an email invitation to a prospective team member.
   * @param {ResendInvitationTeamMemberRequestBody} resendInvitationTeamMemberRequestBody
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TeamsApiInterface
   */
  resendTeamMemberRaw(
    requestParameters: ResendTeamMemberRequest
  ): Promise<runtime.ApiResponse<ResendInviteEmail>>

  /**
   * This endpoint resend an invite email for a prospective team member that previously signed the contract
   * Resend an email invitation to a prospective team member.
   */
  resendTeamMember(
    requestParameters: ResendTeamMemberRequest
  ): Promise<ResendInviteEmail>
}

/**
 *
 */
export class TeamsApi extends runtime.BaseAPI implements TeamsApiInterface {
  /**
   *  Reassigns multiple team members from one supervisor to another in a single operation. This updates the `reportsToActorKey` for each specified actor, effectively moving them under a new supervisor.  ## Permissions: - **User/bulkReassignRoles[their team\'s]** grant allows the calling actor to reassign actors within their downline to report to a new supervisor also within the calling actor\'s downline. The new supervisor must be currently active. - **User/bulkReassignRoles[any]** grant allows the calling actor to reassign any actors to any supervisor. The new supervisor must be currently active.  Note: Users on the front end may select a ton of actors to reassign, and they may not realize they\'ve selected actors that are currently inactive. Instead of returning an error indicating that there are inactive actors in their request, we silently ignore them and reassign the currently active ones.
   */
  async bulkReassignTeamMembersRaw(
    requestParameters: BulkReassignTeamMembersRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling bulkReassignTeamMembers.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/team/bulkReassignTeamMembers`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: BulkReassignTeamMemberRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   *  Reassigns multiple team members from one supervisor to another in a single operation. This updates the `reportsToActorKey` for each specified actor, effectively moving them under a new supervisor.  ## Permissions: - **User/bulkReassignRoles[their team\'s]** grant allows the calling actor to reassign actors within their downline to report to a new supervisor also within the calling actor\'s downline. The new supervisor must be currently active. - **User/bulkReassignRoles[any]** grant allows the calling actor to reassign any actors to any supervisor. The new supervisor must be currently active.  Note: Users on the front end may select a ton of actors to reassign, and they may not realize they\'ve selected actors that are currently inactive. Instead of returning an error indicating that there are inactive actors in their request, we silently ignore them and reassign the currently active ones.
   */
  async bulkReassignTeamMembers(
    requestParameters: BulkReassignTeamMembersRequest
  ): Promise<void> {
    await this.bulkReassignTeamMembersRaw(requestParameters)
  }

  /**
   * Expire a team member on the current user\'s team. This translates to setting the validTo date to the current date for that actor. Also, if available, sets the agreementRecord related to the actor to cancelled and sets the cancelled date.
   */
  async expireTeamMemberRaw(
    requestParameters: ExpireTeamMemberRequest
  ): Promise<runtime.ApiResponse<void>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling expireTeamMember.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/teams/expireTeamMember`,
      method: 'PUT',
      headers: headerParameters,
      query: queryParameters,
      body: ExpireTeamMemberRequestParamsToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.VoidApiResponse(response)
  }

  /**
   * Expire a team member on the current user\'s team. This translates to setting the validTo date to the current date for that actor. Also, if available, sets the agreementRecord related to the actor to cancelled and sets the cancelled date.
   */
  async expireTeamMember(
    requestParameters: ExpireTeamMemberRequest
  ): Promise<void> {
    await this.expireTeamMemberRaw(requestParameters)
  }

  /**
   */
  async fetchInviteTeamMemberOptionsRaw(
    requestParameters: FetchInviteTeamMemberOptionsRequest
  ): Promise<runtime.ApiResponse<InviteTeamMemberOptions>> {
    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/teams/invite/options`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      InviteTeamMemberOptionsFromJSON(jsonValue)
    )
  }

  /**
   */
  async fetchInviteTeamMemberOptions(
    requestParameters?: FetchInviteTeamMemberOptionsRequest
  ): Promise<InviteTeamMemberOptions> {
    const response = await this.fetchInviteTeamMemberOptionsRaw(
      requestParameters || {}
    )
    return await response.value()
  }

  /**
   * It will fetch the users agreements record that was sent out to for the previous and current academic Year for    the logged in user if userId = me in case the end point send query string with the actorKey it will also fetch the actor   downline team agreements for the provided actorKey. It will return the user agreements  sent out for the current    and previous academic year, it will return the Name, Email, Role Date Sent, Type of Invite, and the Status of the invitation.\",
   * Fetch user\'s agreements that was sent out for the previous and current academic year for the logged in user    if the end point send query string with the actorKey it will also fetch the actor downline team agreements for the provided actorKey.
   */
  async fetchTeamAgreementsForUserRaw(
    requestParameters: FetchTeamAgreementsForUserRequest
  ): Promise<runtime.ApiResponse<UserTeamAgreementsResponse>> {
    if (
      requestParameters.userId === null ||
      requestParameters.userId === undefined
    ) {
      throw new runtime.RequiredError(
        'userId',
        'Required parameter requestParameters.userId was null or undefined when calling fetchTeamAgreementsForUser.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.page !== undefined) {
      queryParameters['page'] = requestParameters.page
    }

    if (requestParameters.pageSize !== undefined) {
      queryParameters['pageSize'] = requestParameters.pageSize
    }

    if (requestParameters.orderBy) {
      queryParameters['orderBy'] = requestParameters.orderBy
    }

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    if (requestParameters.invitationStatus !== undefined) {
      queryParameters['invitationStatus'] = requestParameters.invitationStatus
    }

    if (requestParameters.search !== undefined) {
      queryParameters['search'] = requestParameters.search
    }

    if (requestParameters.downlineOnly !== undefined) {
      queryParameters['downlineOnly'] = requestParameters.downlineOnly
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/u/{userId}/team/agreement`.replace(
        `{${'userId'}}`,
        encodeURIComponent(String(requestParameters.userId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      UserTeamAgreementsResponseFromJSON(jsonValue)
    )
  }

  /**
   * It will fetch the users agreements record that was sent out to for the previous and current academic Year for    the logged in user if userId = me in case the end point send query string with the actorKey it will also fetch the actor   downline team agreements for the provided actorKey. It will return the user agreements  sent out for the current    and previous academic year, it will return the Name, Email, Role Date Sent, Type of Invite, and the Status of the invitation.\",
   * Fetch user\'s agreements that was sent out for the previous and current academic year for the logged in user    if the end point send query string with the actorKey it will also fetch the actor downline team agreements for the provided actorKey.
   */
  async fetchTeamAgreementsForUser(
    requestParameters: FetchTeamAgreementsForUserRequest
  ): Promise<UserTeamAgreementsResponse> {
    const response = await this.fetchTeamAgreementsForUserRaw(requestParameters)
    return await response.value()
  }

  /**
   * Send out an email invitation and agreement to a prospective team member.
   */
  async inviteTeamMemberRaw(
    requestParameters: InviteTeamMemberRequest
  ): Promise<runtime.ApiResponse<AgreementRecord>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling inviteTeamMember.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/teams/invite`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: InviteTeamMemberRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AgreementRecordFromJSON(jsonValue)
    )
  }

  /**
   * Send out an email invitation and agreement to a prospective team member.
   */
  async inviteTeamMember(
    requestParameters: InviteTeamMemberRequest
  ): Promise<AgreementRecord> {
    const response = await this.inviteTeamMemberRaw(requestParameters)
    return await response.value()
  }

  /**
   * This endpoint resend an invite email for a prospective team member that previously signed the contract
   * Resend an email invitation to a prospective team member.
   */
  async resendTeamMemberRaw(
    requestParameters: ResendTeamMemberRequest
  ): Promise<runtime.ApiResponse<ResendInviteEmail>> {
    if (
      requestParameters.body === null ||
      requestParameters.body === undefined
    ) {
      throw new runtime.RequiredError(
        'body',
        'Required parameter requestParameters.body was null or undefined when calling resendTeamMember.'
      )
    }

    const queryParameters: any = {}

    const headerParameters: runtime.HTTPHeaders = {}

    headerParameters['Content-Type'] = 'application/json'

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/invite/resendInviteEmail`,
      method: 'POST',
      headers: headerParameters,
      query: queryParameters,
      body: ResendInvitationTeamMemberRequestBodyToJSON(requestParameters.body),
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      ResendInviteEmailFromJSON(jsonValue)
    )
  }

  /**
   * This endpoint resend an invite email for a prospective team member that previously signed the contract
   * Resend an email invitation to a prospective team member.
   */
  async resendTeamMember(
    requestParameters: ResendTeamMemberRequest
  ): Promise<ResendInviteEmail> {
    const response = await this.resendTeamMemberRaw(requestParameters)
    return await response.value()
  }
}
